import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../authentication/auth.service';
import { DashboardSavedViews, DashboardViewStore } from './dashboard-view';

/** Keeps one saved-views document per tenant, user and dashboard in this browser. */
@Injectable()
export class LocalStorageDashboardViewStore implements DashboardViewStore {
  private readonly auth = inject(AuthService);

  async load(dashboardId: string): Promise<unknown> {
    const raw = localStorage.getItem(this.key(dashboardId));
    return raw === null ? null : (JSON.parse(raw) as unknown);
  }

  async save(dashboardId: string, views: DashboardSavedViews): Promise<void> {
    localStorage.setItem(this.key(dashboardId), JSON.stringify(views));
  }

  /** Throws when no user is signed in, since there is no telling whose views to read or write */
  private key(dashboardId: string): string {
    const user = this.auth.user.snapshot;
    if (user?.tenantId == null || user.id == null) {
      throw new Error(`Dashboard "${dashboardId}" views are unavailable; no user is signed in`);
    }

    return `as.dashboard-views.${user.tenantId}.${user.id}.${dashboardId}`;
  }
}
